import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  ar: {
    translation: {
      contact_cta: "إتصل بنا / Contact",
      nav_contact: "اتصال",
      nav_specs: "المواصفات",
      nav_products: "منتجاتنا",
      nav1_product:"سندويج بنل نوعية Rigid Polyurethane (PUR)",
      nav2_product:"سندويج بنل نوعية Polyisocyanurate (PIR)",
      nav_dimensions: "القياسات",
      nav_about: "من نحن",
      badge: "معمل القوة الصناعي",
      title_ar: "معمل القوة",
      title_en: "لانتاج السندويج بنل والصفائح المضلعة كيربي",
      whatsapp_btn: "طلب أسعار عبر واتساب",
      explore_btn: "استكشف منتجاتنا",
      about_heading: "من نحن",
      about_p1: "معمل القوة لصناعة سندويج بنل، هي إحدى المعامل المحلية التي أنشأت في سنة 2017 وبدأت بإنتاج سندويج بنل (الألواح العازلة) منذ سنة 2018 بنوعيه السقفي والجداري.",
      about_p2: "منتوجات معمل القوة تصنع بمكائن أوتوماتيكية وبجودة عالية ووفق معايير عالمية وحسب الطلبيات. تهدف معمل القوة إلى تنمية وتطوير البنية التحتية لبلدنا وتأمين مواد بجودة عالية ومحلية الصنع وزيادة إتاحة فرص عمل للمواطنين.",
      what_is_heading: "ما هو سندويج بنل؟",
      what_is_p: "سندويج بنل منتوج خفيف يتكون من ثلاث طبقات تمنحه ميزات وقدرات فائقة، يتمتع سندويج بنل بمقاومة كبيرة للحرارة وعزل جيد للصوت وخفة وزنه وسهولة تركيبه. تتوسط الطبقة العازلة المصنوعة من مادة بولي يوريثين وبوليسترين بين طبقتين علوية والسفلية مصنوعة من ألواح مضادة للصدأ، تتسم هذه المواد العازلة بخصوص فيزيائية مميز كمقاومتها للحرارة والاشتعال والبرودة مما يقلل من تكاليف استخدام الطاقة.",
      dim_heading: "القياسات وسمك الألواح المنتجة",
      th_features: "المميزات",
      th_roof: "لوحة السقف",
      th_wall: "لوحة الجدار",
      feat_width: "العرض",
      feat_length: "الطول",
      feat_thickness: "سماكة",
      feat_density: "كثافة",
      feat_conductivity: "توصيل حراري",
      feat_sound: "عزل الصوت",
      val_length: "18 م الأعلى",
      val_density: "40 كغم/م3 (∓2)",
      apps_heading: "التطبيقات",
      apps_sub: "يمكن استخدام الألواح العازلة بشكل واسع في مجال البناء والإنشاءات مثل إنشاء:",
      app_showrooms: "🏢 المعارض",
      app_restaurants: "🍔 المطاعم",
      app_pools: "🏊 المسابح",
      app_schools: "🏫 المدارس",
      app_malls: "🛒 الأسواق التجارية الكبيرة",
      app_poultry: "🐔 قاعات حقول الدواجن",
      app_gyms: "🏋️ قاعات الأندية الرياضية",
      app_airports: "✈️ قاعات المطارات",
      prod_heading: "منتجات المعمل",
      specs_heading: "مواصفات سندويج بنل",
      spec_rain: "🌧️ مقاوم للأمطار والأبخرة",
      spec_rust: "🧱 مقاوم للصداء",
      spec_wind: "💨 مقاوم للرياح والعواصف",
      spec_sun: "☀️ عدم التأثر بأشعة الشمس",
      spec_chemical: "🧪 مقاوم للمواد الكيمياوية",
      spec_fire: "🔥 مقاوم للاشتعال",
      spec_heat: "🌡️ عازل لدرجات الحرارة",
      spec_sound: "🔊 عازل للصوت",
      spec_quake: "🌍 مقاوم للصدمات والهزات الأرضية",
      spec_insects: "🐜 مقاوم للحشرات",
      spec_aesthetic: "✨ يتميز بمظهر جميل",
      spec_eco: "🌱 حماية من التلوث البيئي",
      spec_cost: "💰 كلفة قليلة والسرعة في الإنشاء",
      spec_colors: "🎨 متوفر بألوان متعددة",
      spec_durability: "🛡️ High durability",
      spec_recyclable: "🔄 Recyclable",
      video_heading: "شاهد عمليات التصنيع المتقدمة وجودة العمل داخل معمل القوة",
      f_address_title: "📍 العنوان",
      f_address_val: "دهوك ، زاخو ، حسن ئافا ، خلف معرض السيارات",
      f_phone: "📞 هاتف",
      f_email: "✉️ البريد الإلكتروني",
      f_follow: "🌐 تابعونا",
      copyright: "معمل القوة. جميع الحقوق محفوظة.",
      whatsapp_msg: "السلام عليكم، أرید الاستفسار عن منتجات المعمل"
    }
  },
  en: {
    translation: {
      contact_cta: "Contact Us",
      nav_contact: "Contact",
      nav_specs: "Specifications",
      nav_products: "Products",
      nav1_product:"Sandwich Panel Rigid Polyurethane (PUR)",
      nav2_product:"Sandwich Panel Polyisocyanurate (PIR)",
      nav_dimensions: "Available Dimensions & Thickness",
      nav_about: "About Us",
      badge: "Al-Qwa Panel",
      title_ar: "Al-Qwa Panel",
      title_en: "Manufacturer of sandwich panels",
      whatsapp_btn: "Request Prices via WhatsApp",
      explore_btn: "Explore Our Products",
      about_heading: "About Us",
      about_p1: "al-qwa panel is a local factory established in 2017. The factory started to produce sandwich panel for both roof and wall in 2018.",
      about_p2: "The production of this factory is with automated machine and high quality with standard requirements and costumer demands meet. The aim of the factory is to develop and reconstruct the country with a local product and provide more job opportunities.",
      what_is_heading: "Whats Sandwich Panel",
      what_is_p: "Actually sandwich panel is three ply light compound structure, Shows extraordinary performances and advantages. A sandwich panel compound, in comparison with its components has much more resistance and also can be used quickly and easily in constructions. In this modern construction material, insulation polyurethane foam or layers with specific physical features such as defined density and fire resistance class, placed between external and internal layers. These three components are inseparable, and function as integrated object. Whereas are very good heat and cold insulation, using them cause energy costs significantly reduce.",
      dim_heading: "Available Dimensions & Thickness",
      th_features: "Specifications",
      th_roof: "Roof Panel",
      th_wall: "Wall Panel",
      feat_width: "Width",
      feat_length: "Length",
      feat_thickness: "Thickness",
      feat_density: "Density",
      feat_conductivity: "Thermal Conductivity",
      feat_sound: "Sound Isolation",
      val_length: "18 m max",
      val_density: "40 kg/m3 (∓2)",
      apps_heading: "Application",
      apps_sub: "Sandwich panels can be widely used in the field of building and construction, such as the creation of:",
      app_showrooms: "🏢 Showrooms & Offices",
      app_restaurants: "🍔 Restaurants & Theaters",
      app_pools: "🏭 Factories & Warehouses",
      app_schools: "🏫 Schools",
      app_malls: "🛒 Malls & Supermarkets",
      app_poultry: "🐔 Poultry Halls",
      app_gyms: "🏋️ Sport Clubs",
      app_airports: "✈️ Airports & Terminals",
      prod_heading: "Product Types",
      specs_heading: "Specifications",
      spec_rain: "🌧️ Rain and vapor resistance",
      spec_rust: "🧱 Rusting resistance",
      spec_wind: "💨 Wind resistance",
      spec_sun: "☀️ Sun light resistance",
      spec_chemical: "🧪 Chemical resistance",
      spec_fire: "🔥 Fire resistance",
      spec_heat: "🌡️ Heat insulation",
      spec_sound: "🔊 Sound insulation",
      spec_quake: "🌍 Thrust and earthquake resistance",
      spec_insects: "🐜 Insects resistance",
      spec_aesthetic: "✨ Nice appearance",
      spec_eco: "🌱 Protective against pollutions",
      spec_cost: "💰 Cost effective",
      spec_colors: "🎨 Variable colors",
      spec_durability: "🛡️ High durability",
      spec_recyclable: "🔄 Recyclable",
      video_heading: "Watch Our Advanced Manufacturing Operations Inside Al-Qwa Factory",
      f_address_title: "📍 Location",
      f_address_val: "Duhok, Zakho, Hasan Ava, Behind Car Showrooms",
      f_phone: "📞 Phone",
      f_email: "✉️ Email",
      f_follow: "🌐 Follow Us",
      copyright: "Al-Qwa Panel. All Rights Reserved.",
      whatsapp_msg: "Hello, I would like to inquire about the factory's products."
    }
  },
  ku: {
    translation: {
      contact_cta: "پەیوەندیمان پێوە بکە",
      nav_contact: "پەیوەندی",
      nav_specs: "تایبەتمەندییەکان",
      nav_products: "جۆری بەرهەمەکان",
      nav1_product:"سەندەویچی جۆری Rigid Polyurethane (PUR)",
      nav2_product:"سەندەویچی جۆری Polyisocyanurate (PIR)",
      nav_dimensions: "پێوانە و ئەستووری",
      nav_about: "دەربارەی ئێمە",
      badge: "کارگەی قوە پەنەڵ",
      title_ar: "کارگەی قوە پەنەڵ",
      title_en: "بۆ بەرهەمهێنانی سەندەویج پەنەڵ",
      whatsapp_btn: "داواکردنی نرخ لەڕێگەی واتسئاپ",
      explore_btn: "سەیری بەرهەمەکانمان بکە",
      about_heading: "دەربارەی ئێمە",
      about_p1: "کارگەی قوە پەنەڵ كارگەيەكي خۆماڵیه، لەساڵی 2017 دامەزراوه و له ساڵی 2018 دا سەندەویچ پەنەڵی بەرهەمهێنا به هەردوو جۆری دیواری و بنمیچی.",
      about_p2: "بەرهەمی سەندەویچ پەنەڵی پاوەرپەنەڵ بە ئامێری ئۆتۆماتیکی و کوالێتی بەرز و ستاندەری جیهانی و بەپێی داواکاری بەرهەم دەهێنرێن .ئامانجی کارگەی پاوەر پەنەڵ پەرەپێدان ئاوەدانکردنەوە و گەشەپێدانی وڵاتەکەمانە بە بەرهەمێکی خۆماڵی و ڕەخساندنی هەلی کاری زیاتر بۆ هاوڵاتیانە.",
      what_is_heading: "سەندویچ پەنەڵ چییە؟",
      what_is_p: "سەندویچ پەنەڵ بەرهەمێکە کێشی سوکە و لە سێ چین پێکدێت، بەوەش کۆمەڵێک توانا و تایبەتمەندی پێ دەبەخشێ، بەوەی نەگەیەنەرێکی باشە بۆ گەرمی و ساردی و دەنگ و هەروەها ئاسانی بەستان و بەکارهێنانی. لە نێوان دوو چینی دژە ژەنگی پلێتی سەرەوە و خوارەوە چینێک لە ماددەی پۆلی یۆریثین و پۆلیسترین دادەنرێت، ئەو ماددەیە چەند تایبەتمەندییەکی فیزیایی ناوازەی هەیە وەک بەرهەڵستی ئاگر و ساردی و گەرمی، بەوەش بەهای تێچووی بەکارهێنانی وزە کەم دەکاتەوە.",
      dim_heading: "پێوانەو ئەستووری پەنەڵی بەرهەمهاتوو",
      th_features: "تایبەتمەندییەکان",
      th_roof: "پەنەڵی بنمیچ",
      th_wall: "پەنەڵی دیوار",
      feat_width: "پانی",
      feat_length: "درێژی",
      feat_thickness: "ئەستووری",
      feat_density: "چڕی",
      feat_conductivity: "گەیاندنی گەرمى",
      feat_sound: "تێپەڕینی دەنگ",
      val_length: "18 م ماکس",
      val_density: "40 کگم/م3 (∓2)",
      apps_heading: "بەکارهێنانەکانی",
      apps_sub:"ساندویچ پەنەڵ دەکرێت بە شێوەیەکی بەرفراوان لە بواری بیناسازی و تەلارسازیدا بەکاربهێنرێت، وەک دروستکردنی:",
      app_showrooms: "🏢 پێشانگا و کۆگا",
      app_restaurants: "🍔 چێشتخانەکان",
      app_pools: "❄️ کۆگاکانی ساردکەرەوە",
      app_schools: "🏫 قوتابخانەکان",
      app_malls: "🛒 شوێنی بازرگانی",
      app_poultry: "🐔 کێڵگەی پەلەوەر",
      app_gyms: "🏋️ هۆڵی وەرزشی",
      app_airports: "✈️ فڕۆکەخانەکان",
      prod_heading: "جۆری بەرهەمی کارگە",
      specs_heading: "تایبەتمەندییەکانی سەندویچ پەنەڵ",
      spec_rain: "🌧️ دژە باران و هەڵم",
      spec_rust: "🧱 دژە ژەنگ",
      spec_wind: "💨 بەرگری دژی ڕەشەبا و زریان",
      spec_sun: "☀️ بەرگری دژی تیشکی خۆر",
      spec_chemical: "🧪 بەرگری دژی ماددە کیمیاییەکان",
      spec_fire: "🔥 دژە ئاگر",
      spec_heat: "🌡️ دژەگەرمی",
      spec_sound: "🔊 دژە دەنگ",
      spec_quake: "🌍 دژە زەمینلەرزە و لەرینەوە",
      spec_insects: "🐜 دژە مێروو",
      spec_aesthetic: "✨ جوانی لە ڕواڵەت و رێکی لە ئەندازە",
      spec_eco: "🌱 دۆستی ژینگە",
      spec_cost: "💰 نرخی کەم و خێرا لە بنیاتنان",
      spec_colors: "🎨 ڕەنگی جۆراوجۆر",
      spec_durability: "🛡️ توندی پتەوی",
      spec_recyclable: "🔄 توانای دووبارە بەکارهێنانەوە",
      video_heading: "سەیری پڕۆسەی پێشکەوتووی بەرهەمهێنان لە ناو کارگەی قوە پەنەڵ بکە",
      f_address_title: "📍 ناونیشان",
      f_address_val: "دهۆک، زاخۆ، حەسەن ئاڤا، پشت پێشانگای ئۆتۆمبێلەکان",
      f_phone: "📞 تەلەفۆن",
      f_email: "✉️ ئیمێڵ",
      f_follow: "🌐 بەدواداچوونمان بکەن",
      copyright: "کارگەی قوە پەنەڵ. هەموو مافەکان پارێزراون.",
      whatsapp_msg: "سڵاو، دەمەوێت پرسیار بکەم سەبارەت بە بەرهەمەکانی کارگەکە"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ar',
    interpolation: { escapeValue: false }
  });

i18n.on('languageChanged', (lng) => {
  document.body.dir = (lng === 'en') ? 'ltr' : 'rtl';
});

export default i18n;